/** Rewrites the field through `mask`, the caret kept behind the digit it followed. Returns the new text. */
export function applyMask(
  field: HTMLInputElement,
  event: Event,
  mask: (text: string, deleting: boolean) => string,
): string {
  const caret = field.selectionStart ?? field.value.length;
  const before = field.value.slice(0, caret);
  const digitsBefore = before.replace(/\D/g, '').length;
  const afterSeparator = /[^\da-z]$/i.test(before);
  const deleting =
    typeof InputEvent !== 'undefined' && event instanceof InputEvent && event.inputType.startsWith('delete');
  const masked = mask(field.value, deleting);
  if (masked !== field.value) {
    field.value = masked;
    const at = caretAfterDigits(masked, digitsBefore, afterSeparator);
    field.setSelectionRange(at, at);
  }
  return masked;
}

/**
 * Where the caret goes in a masked text so that it stays behind the same number of digits, and behind
 * the separator that follows them when one was just typed.
 */
export function caretAfterDigits(masked: string, digits: number, afterSeparator = false): number {
  let at = masked.length;
  if (digits <= 0) at = 0;
  let seen = 0;
  for (let i = 0; digits > 0 && i < masked.length; i++) {
    if (/\d/.test(masked[i]) && ++seen === digits) {
      at = i + 1;
      break;
    }
  }
  if (afterSeparator && at < masked.length && !/\d/.test(masked[at])) at++;
  return at;
}
